import { render, staticRenderFns } from "./SummaryList.vue?vue&type=template&id=09359f77&"
import script from "./SummaryList.vue?vue&type=script&lang=ts&"
export * from "./SummaryList.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports